import React, { useEffect } from 'react'
import granim from 'granim'

export default function Loader() {
  useEffect(() => {
    new granim({
      element: '#canvas',
      direction: 'diagonal',
      isPausedWhenNotInView: true,
      states : {
        'default-state': {
          gradients: [
            [
              { color: '#c62900', pos: 0 },
              { color: '#e2590a', pos: .2 },
              { color: '#f29100', pos: .6 },
              { color: '#f0da00', pos: 0.9 },
              { color: '#f1e600', pos: 1 },
            ],
            [
              { color: '#c62900', pos: -0.2 },
              { color: '#e2590a', pos: .3 },
              { color: '#f29100', pos: .7 },
              { color: '#f0da00', pos: 1.2 },
              { color: '#f1e600', pos: 1.4 },
            ],
            [
              { color: '#c62900', pos: 0 },
              { color: '#e2590a', pos: .1 },
              { color: '#f29100', pos: .4 },
              { color: '#f0da00', pos: 1 },
              { color: '#f1e600', pos: 1.2 },
            ],
            [
              { color: '#c62900', pos: -0.1 },
              { color: '#e2590a', pos: .3 },
              { color: '#f29100', pos: .6 },
              { color: '#FFC700', pos: 1 },
              { color: '#f0da00', pos: 1.2 },
            ],
          ]
        }
      }
    })
  }, [])
  //  style={{ backgroundImage: 'url("https://images.unsplash.com/photo-1534142499731-a32a99935397?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=634&q=80")', backgroundSize: 'cover' }}
  return (
    <canvas id="canvas" className="fixed w-screen h-screen top-0 left-0 -z-10" />
  )
}

